export default __webpack_public_path__ + "static/media/logo_twitter.76437fda.svg";